/*
 * Purpose : Common component for Alert modal
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import React from 'react'
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from 'reactstrap'

const alertModal = (props) => {
    return (
        <Modal isOpen={props.open} centered={true} toggle={()=>props.handler(false)}> 
                <ModalHeader><font color="#FB8734" >Alert.!</font></ModalHeader>
                <ModalBody>
                    {props.msg}
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" 
                            style={{width:"100%", backgroundColor:"#fb8734", borderColor:"#fff", boxShadow:"0px 1px 2px 2px #C0C0C0"}}
                            onClick={()=>props.handler(false)}>OK</Button>
                </ModalFooter>
        </Modal>
    )
}
export default alertModal
